import { Users } from '@types-lib';

export const LoggedInUserInitialState: Users.LoggedInUserState = {
  user: null,
};
